import { render, staticRenderFns } from "./DigitalDisplaysPage.vue?vue&type=template&id=0e5afa80"
import script from "./DigitalDisplaysPage.vue?vue&type=script&lang=js"
export * from "./DigitalDisplaysPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports